import { MIN_EMPLOYMENT_YEAR } from '../constants';
import { getTotalEmploymentYears } from '../getTotalEmploymentYears';

export function hasMinimumEmploymentYearsBeenMet(): boolean {
    const totalEmploymentYears = getTotalEmploymentYears();
    return totalEmploymentYears < MIN_EMPLOYMENT_YEAR;
}
